import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { raffleService } from '../services/raffleService'

interface UseRafflesProps {
  search: string
  skip: number
  limit: number
  endDate?: Date
  isActive?: boolean
}

export const useRaffles = ({
  search = '',
  skip = 0,
  limit = 10,
  endDate,
  isActive = true,
}: UseRafflesProps) => {
  return useQuery({
    queryKey: ['raffles', search, skip, limit, isActive, endDate],
    queryFn: () =>
      raffleService.findAll(search, skip, limit, endDate, isActive),
    placeholderData: keepPreviousData,
  })
}

export const useRaffleById = (raffleId: string, skip?: boolean) => {
  return useQuery({
    queryKey: ['raffles', raffleId],
    queryFn: () => raffleService.findById(raffleId),
    enabled: !!raffleId && !skip,
  })
}

export const useRafflesHash = (raffleId: string, userId: string) => {
  return useQuery({
    queryKey: ['rafflesHash'],
    queryFn: () => raffleService.getPrizeDrawHash(raffleId, userId),
    enabled: !!raffleId && !!userId,
  })
}
